<div class="basic-info">
  <div *ngIf="banner" class="pb-3 banner text-center">
    <img *ngIf="isImageBanner" width="375" [src]="banner" alt="banner" height="183" onerror="this.src='assets/images/survey-banner.svg'">
    <div class="video-panel" *ngIf="!isImageBanner">
      <video controls name="media" width="375" height="183">
        <source [src]="banner">
      </video>
    </div>
  </div>
  <div *ngIf="!banner" class="pb-3 banner-2 text-center">
    <img src="assets/images/survey-banner.svg" alt="banner" height="183">
  </div>
  <div *ngIf="heading" class="d-flex justify-content-between pb-2">
    <h3 class="heading-3">
      {{heading}}
    </h3>
    <span *ngIf="showDownArrow && paragraph" (click)="showDescription = !showDescription" class="cursor-pointer">
      <img [src]="!showDescription ? 'assets/images/down-arrow.svg' : 'assets/images/up-arrow.svg'" alt="down">
    </span>
  </div>
  <div *ngIf="paragraph && showDescription">
    <p class="paragraph">
      <span class="color-grey-500 mb-3 new-inner-html new-inner-html-list">
        <app-content-card
          [cmt]="paragraph"
          [showChar]="charLimit"
          readMoreCss="cursor-pointer color-blue"
          readLessCss="cursor-pointer color-blue"
          [readMoreText]="mls.languageText.survey_detail.key2"
          [readLessText]="mls.languageText.survey_detail.key3"
          class="survey">
        </app-content-card>
      </span>
    </p>
  </div>

  <div *ngIf="attemptedDate || sponsorName">
    <div class="row">
      <div class="col-sm-6">
        <p class="sponsor color-grey-500" *ngIf="sponsorName">
          <img class="rounded-circle mr-2"
            [ngClass]="{'cursor-pointer': isNavenabled}" 
            [src]="sponsorLogo" 
            onerror="this.src='assets/images/icons/sponsor-default.svg'"
            alt="sponsor-logo" width="20" height="20" (click)="emitSponsorClick()"/>
          {{mls.languageText.survey_detail.key7}} <span class="color-grey-500 d-inline-block cursor-pointer" innerHTML="{{sponsorName}}" (click)="emitSponsorClick()"></span>
        </p>
      </div>
      <div class="col-sm-6 ">
        <p class="date-container" *ngIf="attemptedDate">
          <img class="rounded-circle mr-2" src="assets/themes/icons/survey_clock.svg" alt="logo" width="20" height="20" />
          {{mls?.languageText?.survey_questionnaire?.key57}} {{attemptedDate | formatDate:'DD MMM YYYY'}}
        </p>
      </div>
    </div>
  </div>

</div>
